import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/Main.vue'
import auth from "@/app/auth";
import UserInfoApi from "@/app/user-info-api";
import store from "../store/index.js";
Vue.use(VueRouter);
function requireAuth(to, from, next) {
  let idToken = localStorage.getItem("idToken");
  if (idToken) {
    if (UserInfoApi.checkTokenAvailability(idToken)) {
      if (to.path === "/") {
        next({path: '/main'});
      } else {
        next();
      }
    } else {
      store.state.loggedIn = false;
      localStorage.removeItem("idToken");
      next({
        path: "/logout"
      });
    }
  } else {   
    if (to || from || next) {
      var hash = window.location.hash.substring(1);
      var params = {}
      hash.split('&').map(hk => { 
        let temp = hk.split('='); 
        params[temp[0]] = temp[1] 
      });
      let idToken = params.id_token;
      if (UserInfoApi.checkTokenAvailability(idToken)) {
        localStorage.setItem("idToken", idToken);
        next({
          path: "/main"
        });
      } else {
        store.state.loggedIn = false;
        localStorage.removeItem("idToken");
        next({
          path: "/logout"
        });
      }
    } else {
      store.state.loggedIn = false;
      localStorage.removeItem("idToken");
      next({
        path: "/logout"
      });
    }
  }
}

const routes = [{
    path: '/',
    name: "login",
    beforeEnter: requireAuth
  },
  {
    path: "/login",
    beforeEnter(to, from, next) {
      if (to || from || next) {
        auth.auth.getSession();
        var currUrl = window.location.href;
        console.log(currUrl);
        // auth.auth.parseCognitoWebResponse(currUrl);
      }
    }
  },
  {
    path: "/logout",
    beforeEnter(to, from, next) {
      if (to || from || next) {
        localStorage.removeItem("idToken");
        store.state.loggedIn = false;
        auth.logout();
      }
    }
  },
  {
    path: "/main",
    component: Main,
    beforeEnter: requireAuth
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router